import { render } from "./MessageBar.vue?vue&type=template&id=d0a42a56"
import script from "./MessageBar.vue?vue&type=script&lang=js"
export * from "./MessageBar.vue?vue&type=script&lang=js"

import "./MessageBar.vue?vue&type=style&index=0&id=d0a42a56&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__